import React from "react";
import { Col } from "reactstrap";

import benefits from "assets/img/hyperdrive/benefits.png";

const HyperDriveInfo = ({isMobile, padding}) => {
  return (
    <>
      <h1 className="title text-center" style={{ lineHeight: "140%", marginBottom: '20px', fontWeight: 'bolder' }}>MagLev HyperDrive&trade;</h1>
      <h2 className="text-center" style={{ color: "white", fontSize: isMobile ? '1.25em' : '2em', marginBottom: '20px', fontStyle:'italic' }}>We don’t make the aircraft; we make the propulsion system that makes the aircraft extraordinary.</h2>
      <p className="text-center" style={{ color: "white", fontSize: '1.25em', marginBottom: '10px', paddingLeft: isMobile ? '0em':'3.5em', paddingRight:isMobile ? '0em':'3.5em'}}>
        At the core of MagLev Aero's innovation is an efficiency advantage that can be leveraged to achieve great improvements across each of the key performance parameters of an advanced air mobility vehicle design and air mobility service.
      </p>
      <Col xs={12} className="text-center ml-auto">
        <img src={benefits} alt="benefits" style={{ maxWidth: isMobile ? '100%' : '65%', marginBottom:'20px', marginLeft:'2em'}} />
      </Col>
    </>
  );
};

export default HyperDriveInfo;
